import request from '@/utils/request'

// 查询His系统报告记录列表
export function listHisDiagnosticExaminationReport(query) {
    return request({
        url: '/his/hisDiagnosticExaminationReport/list',
        method: 'get',
        params: query
    })
}

// 查询His系统报告记录详细
export function getHisDiagnosticExaminationReport(id) {
    return request({
        url: '/his/hisDiagnosticExaminationReport/' + id,
        method: 'get'
    })
}

// 新增His系统报告记录
export function addHisDiagnosticExaminationReport(data) {
    return request({
        url: '/his/hisDiagnosticExaminationReport',
        method: 'post',
        data: data
    })
}

// 修改His系统报告记录
export function updateHisDiagnosticExaminationReport(data) {
    return request({
        url: '/his/hisDiagnosticExaminationReport/update',
        method: 'post',
        data: data
    })
}

// 删除His系统报告记录
export function delHisDiagnosticExaminationReport(id) {
    return request({
        url: '/his/hisDiagnosticExaminationReport/delete/' + id,
        method: 'post'
    })
}
